<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h5 class="card-title">Zählerstand</h5>
          </div>
          <div class="col-md-auto text-right">
            <p-button type="success" @click="newZaehlerstand" class="mt-0"><i class="bi bi-file-earmark-plus"></i> Zählerstand erfassen</p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table :data="sortedReadings" stripe empty-text="Es konnten keine Einträge gefunden werden.">
            <el-table-column label="Ablesedatum" width="130" >
              <template slot-scope="scope">
                {{ formatDate(scope.row.date) }}
              </template>
            </el-table-column>
            <el-table-column label="Zählerstand" width="170" align="right" max-width="170">
              <template slot-scope="scope">
                {{ formatKwh(scope.row.value) }}
              </template>
            </el-table-column>
            <el-table-column prop="ableser" label="Ableser" min-width="160" max-width="190"></el-table-column>
            <el-table-column label="Veränderung" min-width="160" max-width="190" align="right">
              <template slot-scope="scope">
                <span v-if="changeToPrevious(scope.$index) !== null" class="text-muted"><i>
                  {{ formatSignedKwh(changeToPrevious(scope.$index)) }}
                  </i>
                </span>
                <span v-else>–</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- NEW Modal -->
    <el-dialog title="Zählerstand erfassen" :visible.sync="newDialog" :close-on-click-modal="false">
      <el-form label-position="top" @keyup.enter.native="addZaehlerstand">
        <el-form-item label="Ablesedatum">
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="Datum wählen"
            :picker-options="pickerOptions1"
            style="width: 100%"
            format="dd.MM.yyyy"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="Zählerstand">
          <el-input :value="formValueStr" @input="onValueInput" placeholder="z.B. 123,45" style="width: 100%">
            <template slot="append">kWh</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <p-button @click="newDialog = false">Abbrechen</p-button>
        <p-button type="primary" @click="addZaehlerstand">Speichern</p-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { db, Timestamp } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Select, Option, Input, InputNumber, Collapse, CollapseItem, MessageBox, Dialog, Form, FormItem, DatePicker } from "element-ui";
import router from "../../../../main";
import moment from "moment-timezone";
import store from "../../../../store";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(DatePicker);

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    MessageBox,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [DatePicker.name]: DatePicker,
  },

  data() {
    return {
      location: store.getters.userlocation,
      role: store.getters.userrole,
      readings: [],
      newDialog: false,
      form: {
        date: new Date(),
        value: null,
      },
      formValueStr: "",
      pickerOptions1: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "Heute",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime());
              picker.$emit("pick", date);
            },
          },
          {
            text: "Gestern",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "Vorgestern",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    if (this.location !== 'FRA') {
      // Only FRA should have access to this view, others are redirected to trainer list
      // show message if user is not from FRA
      MessageBox.alert("Diese Seite steht am gewählten Standort nicht zur Verfügung.", "Zugriff verweigert", {
        confirmButtonText: "OK",
        type: "error",
      }).then(() => { 
        router.push("/ket/overview");
      });
      return;
    } else {
      moment.locale("de");
      this.load();
      store.watch(
        (state) => state.userlocation,
        () => {
          this.location = store.getters.userlocation;
          this.load();
        }
      );
    }
  },
  methods: {
    load() {
      const baseRef = db.collection("zaehlerstaende");
      const query = this.location ? baseRef.where("locationID", "==", this.location) : baseRef;
      query
        .get()
        .then((snapshot) => {
          const items = [];
          snapshot.forEach((doc) => {
            const d = doc.data();
            const dateVal = d.Date && typeof d.Date.toDate === "function" ? d.Date.toDate() : d.date || null;
            items.push({
              key: doc.id,
              date: dateVal,
              value: d.Value !== undefined ? d.Value : d.value,
              ableser: d.Ableser !== undefined ? d.Ableser : d.ableser,
            });
          });
          // Sort newest first
          this.readings = items.sort((a, b) => new Date(b.date) - new Date(a.date));
        })
        .catch((err) => {
          console.error("Fehler beim Laden der Zählerstände:", err);
          this.readings = [];
        });
    },
    newZaehlerstand() {
      this.form = {
        date: new Date(),
        value: null,
      };
      this.formValueStr = "";
      this.newDialog = true;
    },
    addZaehlerstand() {
      if (!this.form.date || this.form.value === null) {
        return;
      }
      const user = store.getters.user && store.getters.user.data ? store.getters.user.data : null;
      const ableser = user ? (user.displayName || user.email || user.uid) : "Unbekannt";
      const payload = {
        Date: Timestamp.fromDate(new Date(this.form.date)),
        Value: Number(this.form.value),
        Ableser: ableser,
        locationID: this.location,
      };
      db.collection("zaehlerstaende")
        .add(payload)
        .then((docRef) => {
          // Update local list immediately
          this.readings.unshift({
            key: docRef.id,
            date: payload.Date.toDate(),
            value: payload.Value,
            ableser: payload.Ableser,
          });
          this.newDialog = false;
        })
        .catch((err) => {
          console.error("Fehler beim Speichern des Zählerstands:", err);
        });
    },
    formatDate(d) {
      const dateObj = d && typeof d.toDate === "function" ? d.toDate() : d;
      return dateObj ? moment(dateObj).format("DD.MM.YYYY") : "";
    },
    onValueInput(val) {
      let s = (val || "").replace(/\./g, ",");
      // Keep only digits and a single comma
      s = s.replace(/[^\d,]/g, "");
      const parts = s.split(",");
      const head = parts[0];
      const tail = parts[1] !== undefined ? parts[1].slice(0, 2) : undefined;
      s = head + (tail !== undefined ? "," + tail : "");
      this.formValueStr = s;
      const num = parseFloat(s.replace(",", "."));
      this.form.value = isNaN(num) ? null : Number(num.toFixed(2));
    },
    formatKwh(val) {
      if (val === null || val === undefined) return "";
      const n = Number(val);
      if (isNaN(n)) return "";
      return n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kWh";
    },
    changeToPrevious(index) {
      // `sortedReadings` is newest-first; previous entry means the next index
      const current = this.sortedReadings[index];
      const previous = this.sortedReadings[index + 1];
      if (!current || !previous) return null;
      const diff = Number(current.value) - Number(previous.value);
      return isNaN(diff) ? null : diff;
    },
    formatSignedKwh(val) {
      if (val === null || val === undefined) return "";
      const n = Number(val);
      if (isNaN(n)) return "";
      const sign = n > 0 ? "+" : (n < 0 ? "-" : "");
      const abs = Math.abs(n).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return `${sign}${abs} kWh`;
    },
  },
  computed: {
    sortedReadings() {
      return [...this.readings].sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
};
</script>
<style>
  .el-form-item__label {
    font-weight: bold;
    line-height: normal !important;
  }
</style>
